import { LocalStorageBoolean } from '../../../util';

const SessionTimeoutKey = 'SessionTimeout';

export function setSessionTimeout(value: boolean = false) {
  return LocalStorageBoolean.set(SessionTimeoutKey, value);
}

export function getSessionTimeout() {
  return LocalStorageBoolean.get(SessionTimeoutKey);
}
